<template>
  <fragment>
    <img class="login-tester" src="@/assets/ebt965p.png" alt="Exide EBT-965P" />
    <p class="text-center font-weight-bolder text-center h2">Exide Battery Tester Programme</p>
    <img class="login-logo mb-3" src="@/assets/exide-logo-black.svg" alt="Exide Technologies" />

    <div
      v-if="this.message"
      class="alert"
      :class="'alert-'+this.message.status"
    >{{ this.message.text }}</div>

    <form>
      <div class="form-group small-label">
        <input
          type="email"
          class="form-control"
          id="login-email"
          :placeholder="$t('login.emailAdress')"
          v-model="email"
        />
        <label v-show="email" for="login-email">{{$t('login.emailAdress')}}</label>
      </div>
      <div class="form-group small-label mb-1">
        <input
          type="password"
          class="form-control"
          id="login-password"
          :placeholder="$t('login.password')"
          v-model="password"
        />
        <label v-show="password" for="login-password">{{$t('login.password')}}</label>
      </div>

      <router-link class="small mb-3 ml-3" to="/password-reset">{{$t('login.forgotPassword')}}</router-link>

      <button
        type="submit"
        class="btn btn-primary btn-block mt-4"
        @click.prevent="submit"
      >{{$t('general.login')}}</button>
      <router-link
        to="/register"
        class="btn btn-outline-primary btn-block mt-3 mb-3"
      >{{$t('general.signUp')}}</router-link>
    </form>
    <p class="ebt965p-info">This app can be used with most digital battery testers, but is optimized for the use with EBT965P battery tester.</p>
  </fragment>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DefaultHeader from '@/partials/DefaultHeader';

export default {
  name: 'Login',
  components: {
    DefaultHeader
  },
  data() {
    return {
      email: '',
      password: ''
    };
  },
  beforeMount() {
    // this.setMessage({
    //   status: null,
    //   text: null
    // });
  },
  methods: {
    ...mapActions(['loginAction', 'setMessage']),
    submit() {
      let credentials = {
        email: this.email,
        password: this.password
      };
      this.loginAction(credentials);
    }
  },
  computed: {
    ...mapGetters({
      message: 'getMessage',
      user: 'getUser'
    })
  },
  watch: {
    user(newValue) {
      if (newValue && newValue.authenticated === true) {
        this.$router.push({ name: 'Dashboard' });
        return;
      }
      this.setMessage({ status: 'danger', text: this.$i18n.t('login.invalidCredentials') });
    }
  }
};
</script>
<style scoped>
  .login-tester {
    max-height: 290px;
  }
  .login-logo {
    max-height: 75px;
  }
  .ebt965p-info {
    font-size: 0.85em;
    font-weight: normal;
    font-style: italic;
    text-align: center;

  }
</style>
